import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getTerminalSubjectDetails } from "../../actions/TerminalSubject.action";
import AddTerminalSubjectForm from "../../components/AddTerminalSubjectForm/AddTerminalSubjectForm";
import Layout from "../../components/shared/Layout/Layout";

const AddTerminalSubjectPage = ({
  edit,
  terminalSubject,
  getTerminalSubjectDetails,
}) => {
  const { id } = useParams();
  useEffect(() => {
    if (edit && id) {
      getTerminalSubjectDetails(id);
    }
  }, [id]);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Terminal Subject`}>
        {edit && id && terminalSubject ? (
          <AddTerminalSubjectForm edit={true} data={terminalSubject} />
        ) : (
          <AddTerminalSubjectForm />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  terminalSubject: state.terminalSubject.selected_terminal_subject,
});

const mapDispatchToProps = {
  getTerminalSubjectDetails,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTerminalSubjectPage);
